import React, { useState } from "react";
import { useAuthActions } from "../hooks/useAuthActions";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";
import { Link } from "react-router-dom";

export default function SignIn() {
  const { signin, signInWithGoogle } = useAuthActions();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [googleError, setGoogleError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signin(email, password);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    setGoogleError("");
    try {
      await signInWithGoogle();
    } catch (err) {
      setGoogleError(err.message);
    }
  };

  return (
    <div className="flex justify-center items-center py-8 min-h-screen bg-gradient-to-br from-primary/10 to-white">
      <div className="w-full max-w-3xl bg-white rounded-2xl shadow-2xl flex overflow-hidden border border-gray-100">
        {/* Illustration or accent section */}
        <div className="hidden md:flex flex-col justify-center items-center bg-primary/90 text-white w-1/2 p-8">
          <h3 className="text-3xl font-bold mb-4">Welcome Back!</h3>
          <p className="text-lg">Sign in to access your personalized study dashboard.</p>
        </div>
        {/* Form section */}
        <form
          onSubmit={handleSubmit}
          className={cn(
            "w-full md:w-1/2 p-8 flex flex-col gap-4 justify-center"
          )}
        >
          <h2 className="text-2xl font-bold text-center mb-2 text-primary">Sign In</h2>
          <button
            type="button"
            onClick={handleGoogleSignIn}
            className="w-full flex items-center justify-center gap-3 py-3 px-4 mb-2 bg-blue-50 border-2 border-blue-100 rounded-lg shadow-sm hover:shadow-md transition-all font-semibold text-gray-700 text-base hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary"
            style={{ fontWeight: 600 }}
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-6 h-6" />
            <span>Sign in with Google</span>
          </button>
          {googleError && <p className="text-red-500 text-center text-sm -mt-2">{googleError}</p>}
          <div className="flex items-center gap-2 my-2">
            <div className="flex-1 h-px bg-gray-200" />
            <span className="text-gray-400 text-xs">or</span>
            <div className="flex-1 h-px bg-gray-200" />
          </div>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="input input-bordered w-full px-4 py-2 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="input input-bordered w-full px-4 py-2 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <div className="flex justify-end mb-2">
            <Link to="/forgot-password" className="text-xs text-primary hover:underline">Forgot Password?</Link>
          </div>
          <Button type="submit" className="w-full mt-2">Sign In</Button>
          {error && <p className="text-red-500 text-center text-sm mt-2">{error}</p>}
          <div className="flex justify-center mt-4">
            <span className="text-sm text-gray-600">Don't have an account? </span>
            <Link to="/signup" className="ml-1 text-primary font-medium hover:underline">Sign Up</Link>
          </div>
        </form>
      </div>
    </div>
  );
} 